<template>
    <div  class="scrollable-content">
        <div ref="scroller" class="scrollable-content-scroller" :class="containerClass">
            <slot></slot>
        </div>
        <div :class="{'show-mobile' : showMobile}">
            <div aria-controls="true" class="scrollable-content-controls">
                <a class="link" @click="move(-1)">
                    <arrow-horizontal :reverse="true" width="50" />
                </a>
                <a class="link" @click.prevent="move(1)">
                    <arrow-horizontal width="50" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>

import ArrowHorizontal from "@/components/Svg/ArrowHorizontal";
export default {
    components: {
        ArrowHorizontal,
    },
    props: {
        containerClass: String,
        showMobile: {
            type: Boolean,
            default: true,
        }
    },


    methods: {

        move(direction) {

            const el = this.$refs.scroller;

            el.scrollLeft += el.clientWidth * direction;
        }
    },
}
</script>
